import * as actionType from './workOrderAction';
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import Cookie from 'js-cookie';
import LZString from 'lz-string';
const config = JSON.parse(Config);
const apiInterface = config['api1'];

const initialState = {
    message: '',
    modalOpen: false,
    loading: false,
    apiStatus:false,
}

export const apiStatus = (data) => ({
    type: actionType.API_CALL_STATUS,
    payload: data,
})
export const GetWorkOrderList = (data) => ({
    
    type: actionType.WORK_ORDER_LIST,
    payload: data,
})
export const GetWorkOrderList1 = (data) => ({
    
    type: actionType.WORK_ORDER_LIST1,
    payload: data,
})
export const GetLoadTicketHistory = (data) => ({
    
    type: actionType.LOAD_TICKET_HISTORY,
    payload: data,
})

export const WorkOrderList = (data)=>({
    type:actionType.IS_WORK_ORDER_LIST,
    payload:data
})

export const PostSelectedData = (data)=>({
    type: actionType.SELECTED_DATA,
    payload:data
})
export const clearWorkOrderDetails = ()=>({
    type:actionType.CLEAR_WORK_ORDER_STORE_INFO,
    payload:""
})
export const comingfromQuotation = (payload)=>({
    type:actionType.COMING_FROM_QUOTATION,
    payload:payload
})
export const doGetWorkOrderInfo= () => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
       const data = {
        'fedid': user['userId'],
    }
    initialState.loading = true;
    dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/loadallWorkRequestInfo',data)
        .then((response) => {
            initialState.loading = false;
            if (response[0]?.Table1[0]?.status_code == '000') {
                const StoreDetails = response[3].Table4;
                // const WorkOrderStoreDetails = response[6].Table7;
                // const WorkOrderStoreData = response[7].Table8;
                const CityDropdownDetails = response[10].Table11;
                const WorkOrderStoreDetails = [];
                const WorkOrderStoreData = []
                const WorkOrderData = {StoreDetails, CityDropdownDetails, WorkOrderStoreDetails, WorkOrderStoreData }
                // const WorkOrderData = {StoreDetails, CityDropdownDetails}
                initialState.message = response[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                dispatch(apiStatus(initialState))
                dispatch(GetWorkOrderList(WorkOrderData))
            }else if(response[0]?.Table1[0]?.status_code == '001'){
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = response[0]?.Table1[0]?.status_msg;
                dispatch(apiStatus(initialState))
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = response[1]?.Table1[2]?.status_msg;
                dispatch(apiStatus(initialState))
            }
        })
        .catch((e) => {
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiStatus(initialState))
            
        })
}


export const loadallWorkRequestInforeact = () => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
          let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
          const user = JSON.parse(decompressedData);
        const data = {
        'fedid': user['userId'],
    }
    initialState.loading = true;
    dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/loadallWorkRequestInforeact',data)
        .then(res=>{
            initialState.loading = false;
            if (res[0]?.Table1[0]?.status_code == '000') {
                // const uniqueStatuses = Object.values(res[5].Table6.reduce((acc, obj) => {
                //     const key = obj.vendor_id;
                //     if (!acc[key])
                //       acc[key] = {...obj };
                //     return acc;
                //   }, {}));
                const VendorDropdownDetails = res[5].Table6;
                const WorkOrderData1 = {VendorDropdownDetails};
                initialState.message = res[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                dispatch(apiStatus(initialState))
                dispatch(GetWorkOrderList1(WorkOrderData1))
            }else if(res[0]?.Table1[0]?.status_code == '001'){
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = res[0]?.Table1[0]?.status_msg;
                dispatch(apiStatus(initialState))
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = res[1]?.Table1[2]?.status_msg;
                dispatch(apiStatus(initialState))
            }
        })
        .catch(e=>{
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiStatus(initialState))
        })
}
export const loadallWorkRequestInfofilterreact = (payload) => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
          let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
          const user = JSON.parse(decompressedData);
        const data = {
        'fedid': user['userId'],
        "storeidlist": payload.storeidlist,
        "vendoridlist" : payload.vendoridlist,
        "priorityList" : payload.priorityList,
        "startdate" : payload.startdate,
        "enddate" : payload.enddate
    }
    initialState.loading = true;
    dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/loadallWorkRequestInfofilterreact',data)
        .then(res=>{
            initialState.loading = false;
            if (res[0]?.Table1[0]?.status_code == '000') {
                
                const StoreDetails = res[3].Table4;
                const WorkOrderStoreDetails = res[6].Table7;
                const WorkOrderStoreData = res[7].Table8;
                const CityDropdownDetails = res[10].Table11;
                const WorkOrderData = {WorkOrderStoreDetails, WorkOrderStoreData, StoreDetails, CityDropdownDetails}
                initialState.message = res[0]?.Table1[0]?.status_msg
                initialState.message = res[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                dispatch(apiStatus(initialState))
                dispatch(GetWorkOrderList(WorkOrderData))
                dispatch(comingfromQuotation(false));
            }else if(res[0]?.Table1[0]?.status_code == '001'){
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = res[0]?.Table1[0]?.status_msg;
                dispatch(apiStatus(initialState))
                dispatch(comingfromQuotation(false));
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = res[1]?.Table1[2]?.status_msg;
                dispatch(apiStatus(initialState))
                dispatch(comingfromQuotation(false));
            }
        })
        .catch(e=>{
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiStatus(initialState))
            dispatch(comingfromQuotation(false));
        })
}

export const reScheduleWorkRequest = (data) => async (dispatch) => {
    initialState.loading = true;
    // dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/PMPInfo/RescheduleWorkRequest', data)
        .then((result) => {console.log(result,'rescheduleData')
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[1].Table2[0].status_msg
                initialState.apiStatus=true;
                initialState.loading = false;
                initialState.modalOpen = true;
                dispatch(apiStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.loading = false;
                initialState.message = result[0]?.Table1[0]?.status_msg
                // dispatch(APIStart(initialState))
                dispatch(apiStatus(initialState))
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            // dispatch(APIStart(initialState))
            dispatch(apiStatus(initialState))
        })
}

export const doAcceptWorkRequest = (data) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/PMPInfo/AcceptWorkRequest', data)
        .then((result) => {console.log(result,'acceptWorkRequest')
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[1].Table2[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                initialState.loading = false;
                dispatch(apiStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.loading = false;
                initialState.message = result[0]?.Table1[0]?.status_msg
                // dispatch(APIStart(initialState))
                dispatch(apiStatus(initialState))
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            // dispatch(APIStart(initialState))
            dispatch(apiStatus(initialState))
        })
}

export const doRejectWorkRequest = (data) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/PMPInfo/RejectWorkRequest', data)
        .then((result) => {console.log(result,'RejectWorkRequest')
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[1].Table2[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                initialState.loading = false;
                dispatch(apiStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.loading = false;
                initialState.message = result[0]?.Table1[0]?.status_msg
                // dispatch(APIStart(initialState))
                dispatch(apiStatus(initialState))
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            // dispatch(APIStart(initialState))
            dispatch(apiStatus(initialState))
        })
}

export const loadTicketHistory= (workrequestid) => async (dispatch) => {
    const data = {
        'workrequestid': workrequestid,
    }
    initialState.loading = true;
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/LoadTicketHistory',data)
        .then((response) => {
            initialState.loading = false;
            console.log(response,'response form loadTicketHistory')
            if (response[0]?.Table1[0]?.status_code == '000') {
                const TicketHistory = response[1]?.Table2;
                initialState.message = response[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                dispatch(GetLoadTicketHistory(TicketHistory))
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = response[1]?.Table1[2]?.status_msg;
            }
        })
        .catch((e) => {
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            
        })
}

